import { render, staticRenderFns } from "./ChiTietHocTap.vue?vue&type=template&id=52c4b572&scoped=true&xmlns%3Awhite-space=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./ChiTietHocTap.vue?vue&type=script&lang=js"
export * from "./ChiTietHocTap.vue?vue&type=script&lang=js"
import style0 from "./ChiTietHocTap.vue?vue&type=style&index=0&id=52c4b572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4b572",
  null
  
)

export default component.exports